import { REBUILD_ROUTERS } from '@rebuild/router/rebuild';
import { LEGACY_ROUTES } from './modules';
import EnterpriseImagePreview from '@/views/image-preview';
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
	...REBUILD_ROUTERS,
	...LEGACY_ROUTES,

	{
		path: '/investors/:token',
		name: 'enterprise_iframe_with_token',
		component: () => import('@/views/layout/MIframe.vue'),
		meta: {
			from: 'copyLink'
		}
	},
	{
		// 兼容域名情况下的移动端模板链接访问
		path: '/irm-mobile/enterprise/*',
		name: 'enterprise_iframe_with_mobile',
		component: () => import('@/views/layout/MIframe.vue'),
		meta: {
			from: 'withMobile'
		}
	},

	{
		path: '/preview',
		name: 'enterprise_preview',
		component: EnterpriseImagePreview,
		meta: {}
	},

	{
		path: '*',
		name: '404',
		component: () => import(/* webpackChunkName: "index" */ '@/views/ViewTo404.vue'),
		meta: {}
	},
	{
		path: '/cancel-email',
		name: 'cancel_email',
		component: () => import('@/views/cancel-email.vue'),
		meta: {}
	}
];

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});

// 全局处理 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject);
	}
	return originalPush.call(this, location).catch(error => {
		if (VueRouter.isNavigationFailure(error)) {
			// resolve error
			return error;
		}
		// throw error
		return Promise.reject(error);
	});
};
// 同样处理 replace 方法
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalReplace.call(this, location, onResolve, onReject);
	}
	return originalReplace.call(this, location).catch(error => {
		if (VueRouter.isNavigationFailure(error)) {
			// resolve error
			return error;
		}
		// throw error
		return Promise.reject(error);
	});
};

router.beforeEach((to, from, next) => {
	if (
		store.state.storeKeepAlive.keepAliveRules[from.name] &&
		store.state.storeKeepAlive.keepAliveRules[from.name].includes(to.name)
	) {
		if (!store.state.storeKeepAlive.cachePages.includes(from.name)) {
			store.commit('storeKeepAlive/addInclude', from.name);
		}
	} else {
		store.commit('storeKeepAlive/removeInclude', from.name);
	}

	next();
});

export default router;
